import { render, staticRenderFns } from "./ConfirmResultDialog.vue?vue&type=template&id=581fa60a&lang=pug"
import script from "./ConfirmResultDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmResultDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmResultDialog.vue?vue&type=style&index=0&id=581fa60a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports